"use client";
import { useEffect } from "react";

import { STORAGE_SESSION_ID_KEY } from "@/lib/constants";
import { initializeSessionId } from "@/lib/utils/user-session-id";

export default function Session() {
  useEffect(() => {
    initializeSessionId({
      storageSessionIdKey: STORAGE_SESSION_ID_KEY,
      uuid: true,
    });
  }, []);
  return null;
}
